import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../BaseUrl/baseurl";
import axios from "axios";
const token = localStorage.getItem("token");
const headers = {
    headers: {
        authorization: token
    }
};

export const getAdminRoleList = createAsyncThunk(
    "getAdminRoleList",
    async () => {
        const response = await axios.get(`${baseUrl}/adminroles`, headers);
        return response.data;
    }
);

export const getManagersList = createAsyncThunk("getManagerList", async () => {
    let response;
    try {
        response = await axios.get(`${baseUrl}/managers`, headers);
    } catch (error) {
        console.error("getManagersListError", error);
        return [];
    }

    return response.data;
});

export const getManagerbyId = createAsyncThunk("getManagerbyId", async id => {
    let response;
    try {
        response = await axios.get(`${baseUrl}/managers/${id}`, headers);
    } catch (error) {
        console.error("get Manager By ID", error);
        return undefined;
    }
    // console.log("Manager Slice",response.data)
    return response.data;
});

const managerslice = createSlice({
    name: "ManagerData",

    initialState: {
        AdminRole: [],
        isSuperAdmin: false,
        managerAccessList: {},
        accessList: {},
        Managers: [],
        Manager: {},
        ManagerByid: {},
        status: "",
        error: ""
    },

    reducers: {
        addAccessList: (state, action) => {
            const propertyName = action.payload;

            // Check if the property exists
            if (state.accessList.hasOwnProperty(propertyName)) {
                // Toggle the existing property
                state.accessList[propertyName] =
                    !state.accessList[propertyName];
            } else {
                // If the property doesn't exist, create it with a value of true
                state.accessList[propertyName] = true;
            }
        },

        setManagerAccessList: (state, action) => {
            // console.log("action.payload for allow acces manager", action.payload)
            state.managerAccessList = JSON.parse(action.payload);
        },

        setIsSuperAdminState: (state, action) => {
            // console.log("admin role payload", action.payload);
            if (action.payload === "2") {
                state.isSuperAdmin = true;
            } else {
                state.isSuperAdmin = false;
            }
        }
    },

    extraReducers(builder) {
        // add buyer
        builder
            .addCase(getManagersList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getManagersList.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.Managers = action.payload;
            })
            .addCase(getManagersList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(getManagerbyId.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getManagerbyId.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.Manager = action.payload;
            })
            .addCase(getManagerbyId.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(getAdminRoleList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getAdminRoleList.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.AdminRole = action.payload;
            })
            .addCase(getAdminRoleList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});

export const { addAccessList, setManagerAccessList, setIsSuperAdminState } =
    managerslice.actions;
export default managerslice.reducer;
